import { getBundleParams } from "@bundles/parts/utils"
import { useUser, useWorkTaskId } from "@tm/context-distribution"
import { Autocomplete } from "@tm/data"
import { useLocalization } from "@tm/localization"
import { channel } from "@tm/models"
import { renderRoute, encodeUniqueId, TmaHelper, uniqueId } from "@tm/utils"
import { useState, useEffect, useCallback } from "react"
import { useParams, useHistory } from "react-router"
import { SearchField } from "./SearchField"

type UniSearchFieldProps = {
    universalSearchRoute: string
}

export function UniSearchField({ universalSearchRoute }: UniSearchFieldProps) {
    const { userContext } = useUser()
    const { translateText } = useLocalization()
    const params = useParams()
    const workTaskId = useWorkTaskId()
    const history = useHistory()
    const [currentShortcutKey, setCurrentShortcutKey] = useState<string>("")

    useEffect(() => {
        const unsubscribe = channel("APP").subscribe("SHORTCUTS", (rez) => {
            if (rez.key === "UNI") {
                setCurrentShortcutKey(rez.key + Math.random())
            }
        })
        return unsubscribe
    }, [])

    const handleUniSearch = useCallback(
        (query: string) => {
            const url = renderRoute(universalSearchRoute, {
                ...params,
                workTaskId: encodeUniqueId(workTaskId ?? uniqueId()),
            })
            const queryUrl = `${url}?query=${query}`

            TmaHelper.UniParts.Search.KeywordSearchFromStartPage(query, queryUrl)
            history.push(queryUrl)
        },
        [history, params, universalSearchRoute, workTaskId]
    )

    return (
        <SearchField
            key={currentShortcutKey}
            placeholder={translateText(194)}
            minLengthForSearch={getBundleParams().minimumSearchLength.universalSearch}
            onSearch={handleUniSearch}
            autofocus
            autofocusTimeout={100}
            getSuggestions={(query) => Autocomplete.getUniversalProductGroups(userContext, query)}
        />
    )
}
